import type { ReactNode } from 'react';
import { Text, UnstyledButton } from '@mantine/core';

export default function AnchorButton({
  onClick,
  children,
}: {
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <UnstyledButton
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
      }}
    >
      <Text
        size="sm"
        fw={400}
        lh={1.25}
        lineClamp={1}
        c="blue"
        td="underline"
        style={{
          display: 'inline-block',
          fontVariantNumeric: 'tabular-nums',
          transition: 'color 120ms ease',
        }}
        styles={{
          root: {
            textDecoration: 'none',
          },
        }}
      >
        {children}
      </Text>
    </UnstyledButton>
  );
}
